import React from "react";
import ServiceDetailLayout from "./ServiceDetailLayout";

export default function MobileDetail() {
	return (
		<ServiceDetailLayout
			title="Applications Mobiles"
			summarySections={[
				{ id: "intro", label: "Introduction" },
				{ id: "pourquoi", label: "Pourquoi une app mobile ?" },
				{ id: "avantages", label: "Bénéfices pour votre activité" },
				{ id: "fonctionnalites", label: "Fonctionnalités clés" },
				{ id: "securite", label: "Sécurité & RGPD" },
				{ id: "accompagnement", label: "Accompagnement & support" },
				{ id: "process", label: "Notre Processus" },
				{ id: "faq", label: "FAQ" }
			]}
		>
			<section id="intro">
				<h2>Introduction</h2>
				<p>
					Notre pôle mobile accompagne les entreprises de toutes tailles dans la conception, le développement et le déploiement d’applications mobiles à forte valeur ajoutée. Nous intervenons sur des projets stratégiques, du cadrage à la maintenance, en garantissant une expérience utilisateur irréprochable et une performance optimale. Nos équipes pluridisciplinaires, composées de chefs de projet, designers UX/UI, architectes et développeurs seniors, s’appuient sur des méthodologies éprouvées pour transformer vos idées en solutions mobiles innovantes, robustes et évolutives.
				</p>
			</section>
			<section id="pourquoi">
				<h2>Pourquoi une app mobile&nbsp;?</h2>
				<p>
					Dans un monde où la mobilité est devenue un levier de croissance incontournable, disposer d’une application mobile permet de renforcer la proximité avec vos clients, d’optimiser vos processus internes et de créer de nouveaux canaux de revenus. Une app mobile offre une disponibilité 24/7, une personnalisation avancée de l’expérience utilisateur, et la possibilité d’exploiter des fonctionnalités natives (notifications, géolocalisation, biométrie, etc.) pour se différencier sur votre marché. Elle s’intègre parfaitement à votre écosystème digital et accompagne la transformation digitale de votre organisation.
				</p>
			</section>
			<section id="avantages">
				<h2>Bénéfices pour votre activité</h2>
				<p>
					• Amélioration de la satisfaction et de la fidélisation client grâce à une interface fluide et intuitive.<br />
					• Accélération de la prise de décision via l’accès en temps réel à l’information.<br />
					• Automatisation de tâches récurrentes et réduction des coûts opérationnels.<br />
					• Valorisation de votre image de marque par l’innovation et la modernité.<br />
					• Collecte et analyse de données pour piloter votre activité et anticiper les besoins du marché.
				</p>
			</section>
			<section id="fonctionnalites">
				<h2>Fonctionnalités clés</h2>
				<p>
					Nous concevons des applications sur-mesure intégrant des fonctionnalités avancées telles que :<br />
					• Authentification sécurisée (SSO, biométrie, double facteur)<br />
					• Notifications push ciblées et programmables<br />
					• Paiement in-app et gestion d’abonnements<br />
					• Intégration de services tiers (API, CRM, ERP, IoT)<br />
					• Mode hors-ligne et synchronisation intelligente<br />
					• Gestion de contenu dynamique et personnalisation utilisateur<br />
					• Tableaux de bord analytiques et reporting en temps réel<br />
					Chaque projet bénéficie d’un accompagnement sur la définition des fonctionnalités prioritaires et d’une roadmap évolutive.
				</p>
			</section>
			<section id="securite">
				<h2>Sécurité & RGPD</h2>
				<p>
					La sécurité est au cœur de notre démarche : nous appliquons les meilleures pratiques du secteur (chiffrement des données, audits réguliers, gestion fine des accès, conformité RGPD) et collaborons avec des partenaires spécialisés pour garantir la protection de vos données et de celles de vos utilisateurs. Nos solutions sont hébergées sur des infrastructures certifiées et bénéficient d’un monitoring 24/7, avec des plans de reprise d’activité et de sauvegarde adaptés à vos enjeux métiers.
				</p>
			</section>
			<section id="accompagnement">
				<h2>Accompagnement & support</h2>
				<p>
					Nous proposons un accompagnement global, de la phase de conseil stratégique à la maintenance évolutive. Nos experts vous assistent dans la rédaction du cahier des charges, la définition des KPIs, la formation de vos équipes et la gestion du changement. Un support technique réactif et personnalisé est assuré tout au long du cycle de vie de votre application, avec des engagements de service (SLA) adaptés à vos besoins et une veille technologique continue pour anticiper les évolutions du marché.
				</p>
			</section>
			<section id="process">
				<h2>Notre Processus</h2>
				<ol>
					<li>Atelier de cadrage stratégique avec vos parties prenantes</li>
					<li>Design thinking et prototypage UX/UI</li>
					<li>Développement agile avec sprints courts et livraisons fréquentes</li>
					<li>Tests utilisateurs, audits de sécurité et validation métier</li>
					<li>Déploiement sur les stores et accompagnement à la mise en production</li>
					<li>Suivi post-lancement, maintenance et évolutions continues</li>
				</ol>
			</section>
			<section id="faq">
				<h2>FAQ</h2>
				<p>
					Vous avez une question sur la création, la refonte ou la maintenance d’une application mobile&nbsp;? Nos consultants sont à votre disposition pour vous apporter des réponses précises et des retours d’expérience concrets, quel que soit votre secteur d’activité ou la maturité de votre projet.
				</p>
			</section>
		</ServiceDetailLayout>
	);
}
